var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getShiftsByMissionIdFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
import { useShiftParticipantActions } from './useShiftParticipantActions';
export const shiftsFetchKey = 'shifts';
export const useShiftsByMissionId = ({ missionId, isVolunteerView }) => {
    const getShiftsByMissionIdPlatformFn = useTypedPlatformFunction(getShiftsByMissionIdFunctionDef);
    const fetchShiftsByMissionId = (missionId) => __awaiter(void 0, void 0, void 0, function* () {
        const result = (yield getShiftsByMissionIdPlatformFn({
            missionId,
            isVolunteerView,
        })); // TODO: Remove Type Casting after PLAT-2704
        return result;
    });
    const { handleApprove: handleApproveAction, handleDeny: handleDenyAction, handleSubmit: handleSubmitRequestAction, handleWithdraw: handleWithdrawAction, handleSelfWithdrawal: handleSelfWithdrawalAction, sendMessageToVolunteers: handleSendMessageToVolunteersAction, handleApproveHours: handleApproveHoursAction, } = useShiftParticipantActions();
    const { data: shifts, mutate, isLoading, } = useSWR([shiftsFetchKey, missionId, isVolunteerView], ([, paramsMissionId]) => {
        return fetchShiftsByMissionId(paramsMissionId).catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    const handleApprove = (approveParams) => {
        return handleApproveAction(approveParams);
    };
    const handleWithdraw = (withdrawParams) => {
        return handleWithdrawAction(withdrawParams);
    };
    const handleSelfWithdrawal = (withdrawParams) => {
        return handleSelfWithdrawalAction(withdrawParams);
    };
    const handleSubmitRequest = (requestParams) => {
        return handleSubmitRequestAction(requestParams);
    };
    const handleDeny = (denyParams) => {
        return handleDenyAction(denyParams);
    };
    const handleApproveHours = (approveHoursParams) => {
        return handleApproveHoursAction(approveHoursParams);
    };
    const currentDateTimeInMs = Date.now();
    const upcomingShifts = shifts ? shifts.filter((s) => s.columns.stopTime >= currentDateTimeInMs) : [];
    const pastShifts = shifts ? shifts.filter((s) => s.columns.stopTime < currentDateTimeInMs) : [];
    return {
        fetchShifts: () => __awaiter(void 0, void 0, void 0, function* () {
            yield mutate();
        }),
        shifts,
        isLoading,
        handleApprove,
        handleDeny,
        handleSendMessageToVolunteersAction,
        handleSubmitRequest,
        handleWithdraw,
        handleSelfWithdrawal,
        upcomingShifts,
        pastShifts,
        handleApproveHours,
    };
};
